import { Nav } from '../sections/Nav';
import { Hero } from '../sections/Hero';
import { Features } from '../sections/Features';
import { HowItWorks } from '../sections/HowItWorks';
import { AppSourceReviews } from '../sections/AppSourceReviews';
import { Waitlist } from '../sections/Waitlist';
import { FAQ } from '../sections/FAQ';
import { Footer } from '../sections/Footer';

export function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <AppSourceReviews />
        <Waitlist />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}
